/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { get } from 'lodash';
import { isEmail } from 'validator';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, TextField, Button, MenuItem, Grid } from '@mui/material';

import axios from '../../services/axios';
import { Container, Title } from '../../styles/GlobalStyles';
import Loading from '../../components/Loading';
import * as actions from '../../store/modules/auth/actions';

export default function Cadastro() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // User
  const { id } = useParams();
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [flag_admin, setFlag] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const textData = 'Usuário';
  const tableDatas = 'users';

  async function getData() {
    try {
      setIsLoading(true);

      const { data } = await axios.get(`/${tableDatas}/${id}`);
      setNome(data.nome);
      setEmail(data.email);
      setPassword(data.password);
      setFlag(data.flag_admin);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      const status = get(err, 'response.status', 0);
      const errors = get(err, 'response.data.errors', []);

      if (status === 400) errors.map((error) => toast.error(error));
      navigate(`/${tableDatas}`);
    }
  }

  useEffect(() => {
    if (!id) {
      return; // se não for alteração
    }
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let formErrors = false;

    if (nome.length < 3 || nome.length > 255) {
      formErrors = true;
      toast.error('Nome deve ter entre 3 e 255 caracteres');
    }

    if (!isEmail(email)) {
      formErrors = true;
      toast.error('E-mail inválido.');
    }

    if (!id && (password.length < 6 || password.length > 50)) {
      formErrors = true;
      toast.error('Senha deve ter entre 6 e 50 caracteres');
    }

    if (formErrors) return;

    try {
      setIsLoading(true);

      if (id) {
        await axios.put(`/${tableDatas}/${id}`, {
          nome,
          email,
          password,
          flag_admin,
        });
        toast.success(`Registro alterado com sucesso!`);
        navigate(`/${tableDatas}/`);
      } else {
        await axios.post(`/${tableDatas}/`, {
          nome,
          email,
          password,
          flag_admin,
        });
        toast.success(`Registro cadastrado com sucesso!`);
        navigate(`/${tableDatas}/`);
      }

      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      const status = get(err, 'response.status', 0);
      const data = get(err, 'response.data', {});
      const errors = get(data, 'errors', []);

      if (errors.length > 0) {
        errors.map((error) => toast.error(error));
      } else {
        toast.error('Erro desconhecido');
      }

      if (status === 401) dispatch(actions.loginFailure());
    }
  };

  const nivelAcesso = [
    { nome: 'Administrador', id: 0 },
    { nome: 'Estratégico', id: 1 },
    { nome: 'Operacional', id: 2 },
    { nome: 'Motorista', id: 3 },
    { nome: 'Integração', id: 4 },
  ];

  return (
    <Container>
      <Loading isLoading={isLoading} />
      <Title>{id ? `Alterar ${textData}` : `Novo ${textData}`}</Title>

      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          '& .MuiTextField-root': { m: 0, width: { xs: '100%', sm: '100%' } },
        }}
      >
        <Grid container spacing={1} justifyContent="center">
          <Grid item xs={12} sm={12}>
            <TextField
              required
              value={nome}
              label="Username"
              onChange={(e) => setNome(e.target.value)}
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              required
              value={email}
              label="E-mail"
              size="small"
              onChange={(e) => setEmail(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              required
              type="password"
              value={password}
              label="Senha"
              size="small"
              onChange={(e) => setPassword(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              required
              select
              value={flag_admin}
              label="Nivel de Acesso"
              onChange={(e) => setFlag(e.target.value)}
              size="small"
            >
              {nivelAcesso.map((table) => (
                <MenuItem key={table.id} value={table.id}>
                  {table.nome}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <Button
              type="button"
              color="secondary"
              variant="contained"
              onClick={handleSubmit}
            >
              {id ? 'Alterar' : 'Cadastrar'}
            </Button>
            <Button type="button" onClick={() => navigate(`/${tableDatas}`)}>
              Cancelar
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}
